<template>
    <div class="pdd-tools">
        <el-row class="section">
            <el-col :span="24">
                <el-tabs type="border-card" v-model="currentTab">
                    <el-tab-pane label="渠道推广" name="channel">
                        <channel></channel>
                    </el-tab-pane>
                    <el-tab-pane label="营销工具" name="promotion">
                        <promotion></promotion>
                    </el-tab-pane>
                    <el-tab-pane label="红包" name="redpacket">
                        <redpacket></redpacket>
                    </el-tab-pane>
                    <el-tab-pane label="转盘免单" name="free-order">
                        <free_order></free_order>
                    </el-tab-pane>
                </el-tabs>
            </el-col>
        </el-row>
    </div>

</template>
<script>

    export default {
        name: "index",
        components: {
            free_order: require('./free_order').default,
            redpacket: require('./redpacket').default,
            promotion: require('./promotion').default,
            channel: require('./channel').default,
        },
        watch: {},
        created() {
            var search = window.location.search
            var parts = search.split("=")
            if (parts.length == 2) {
                this.currentTab = parts[1]
            }

        },
        mounted() {


        },
        data() {
            return {
                currentTab: 'channel',
            }
        },
        methods: {}
    }

</script>
<style lang="scss">

    .pdd-tools {
        text-align: left;

        .head-tip {
            margin-left: 10px;
            color: #ff0036;
        }

        .title {
            margin-left: 10px;
            display: flex;
            align-items: center;

            .trigger {
                margin-left: 20px;
            }

            strong {
                color: $hover-color;
            }

        }

        .el-collapse {
            border: none;
        }

        .el-collapse-item__wrap {
            border: none;
        }


        .el-collapse-item__content {
            padding-bottom: 0px;
        }
    }

</style>